import controller from './kelse.controller';
import template from './kelse.html';

export default {
	template,
	bindings: {
		form: '<',
		kid: '<',
		parent: '=',
	},
	controller,
	controllerAs: '$ctrl',
};
